export const countryToFlag = (isoCode) => `https://flagcdn.com/32x24/${isoCode}.png`